import React from 'react';

import '../../../static/scss/components/ui/radio.scss';

type Props = {
  name: string,
  onChange: () => {},
  checked: boolean,
  value: ?string,
  id?: string,
  cypress?: string | null
};

const Radio = ({
  name,
  onChange,
  checked,
  value,
  id = '',
  cypress = null
}: Props) => (
  <span className={`c-radio ${checked ? 'c-radio--checked' : ''}`}>
    <input
      type="radio"
      name={name}
      onChange={onChange}
      checked={checked}
      value={value}
      id={id}
      data-cy={cypress}
    />
  </span>
);

export default Radio;
